export const ErrorType = {
  invalidToken: 'Invalid Token',
  existingEmail: 'User with this email already exists',
}

export const errorMsg = {
  existingEmail:
    'It looks like you already have an account with that email address. Please login below',
}
